import { render, staticRenderFns } from "./tabs-tenancy-view.vue?vue&type=template&id=9f8bd48e&"
import script from "./tabs-tenancy-view.vue?vue&type=script&lang=js&"
export * from "./tabs-tenancy-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports